module.exports = Roo.Divider;